export default __webpack_public_path__ + "static/media/SMB320-Agricultural-drone.9abe6109.jpg";